import { BusinessPlanOptions, Addons } from '../locale';
import { roundTo, toCurrency } from '../utils';

export const calculateBusinessPlanCost = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  return toCurrency(
    selectedBusinessPlanAddons.tier1 * addons.tier1.price +
      selectedBusinessPlanAddons.tier2 * addons.tier2.price +
      selectedBusinessPlanAddons.tier3 * addons.tier3.price,
  );
};

export const calculateBusinessPlanCarbon = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  return (
    selectedBusinessPlanAddons.tier1 * addons.tier1.stats.carbon +
    selectedBusinessPlanAddons.tier2 * addons.tier2.stats.carbon +
    selectedBusinessPlanAddons.tier3 * addons.tier3.stats.carbon
  );
};

export const calculateBusinessPlanAnnualCarbon = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  const tier1Total =
    selectedBusinessPlanAddons.tier1 * (addons.tier1.stats.carbonAnnual || addons.tier1.stats.carbon * 12);

  const tier2Total =
    selectedBusinessPlanAddons.tier2 * (addons.tier2.stats.carbonAnnual || addons.tier2.stats.carbon * 12);

  const tier3Total =
    selectedBusinessPlanAddons.tier3 * (addons.tier3.stats.carbonAnnual || addons.tier3.stats.carbon * 12);

  return roundTo(2)(tier1Total + tier2Total + tier3Total);
};

export const calculateBusinessPlanTrees = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  return (
    selectedBusinessPlanAddons.tier1 * addons.tier1.stats.trees +
    selectedBusinessPlanAddons.tier2 * addons.tier2.stats.trees +
    selectedBusinessPlanAddons.tier3 * addons.tier3.stats.trees
  );
};

export const calculateBusinessPlanAnnualTrees = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  const tier1Total = selectedBusinessPlanAddons.tier1 * addons.tier1.stats.trees * 12;

  const tier2Total = selectedBusinessPlanAddons.tier2 * addons.tier2.stats.trees * 12;

  const tier3Total = selectedBusinessPlanAddons.tier3 * addons.tier3.stats.trees * 12;

  return roundTo(2)(tier1Total + tier2Total + tier3Total);
};

export const calculateBusinessPlanFootprints = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  return (
    selectedBusinessPlanAddons.tier1 * (addons.tier1.stats.footprints || 0) +
    selectedBusinessPlanAddons.tier2 * (addons.tier2.stats.footprints || 0) +
    selectedBusinessPlanAddons.tier3 * (addons.tier3.stats.footprints || 0)
  );
};

export const calculateBusinessPlanTotals = (addons: Addons, selectedBusinessPlanAddons: BusinessPlanOptions) => {
  return {
    employees: selectedBusinessPlanAddons.tier1 + selectedBusinessPlanAddons.tier2 + selectedBusinessPlanAddons.tier3,
    price: calculateBusinessPlanCost(addons, selectedBusinessPlanAddons),
    carbon: calculateBusinessPlanCarbon(addons, selectedBusinessPlanAddons),
    carbonAnnual: calculateBusinessPlanAnnualCarbon(addons, selectedBusinessPlanAddons),
    trees: calculateBusinessPlanTrees(addons, selectedBusinessPlanAddons),
    treesAnnual: calculateBusinessPlanAnnualTrees(addons, selectedBusinessPlanAddons),
    footprints: calculateBusinessPlanFootprints(addons, selectedBusinessPlanAddons),
  };
};
